'use client'

import { SupportUsMessage } from '@/components/common/SupportUs'

import styles from './SidebarAd.module.scss'

export const SidebarAd = () => {
  const className = 'mvSidebar1'

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={className} />
        <SupportUsMessage />
      </div>
    </div>
  )
}
